import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { SelfcorrectingService } from '../selfcorrecting.service';
import * as shape from 'd3-shape';

@Component({
  selector: 'app-t-create-codes',
  templateUrl: './t-create-codes.component.html',
  styleUrls: ['./t-create-codes.component.css']
})
export class TCreateCodesComponent extends GeneralTeacherComponent {

  lengthOfCodes: number;
  numberOfCodes: number;
  minimalDistance: number;
  values: string[] = [];
  givenCodes: string[] = [];
  modus: string;
  showCube: boolean;

  countErrors: number;
  useValues: boolean;
  existingCodes: boolean;
  noLength: boolean;
  noCount: boolean;

  view: any[] = [600, 300];
  fitContainer: boolean = true;
  curve = shape.curveBundle;
  nodes: any[] = [];
  edges: any[] = [];



  constructor(topicService: TopicService, activatedRoute: ActivatedRoute, protected selfcorrectingService: SelfcorrectingService) {
    super(topicService, activatedRoute)
    this.type = "createCodes";
    this.title = this.get("createCodes");
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.lengthOfCodes = this.configuration.typespecifics.lengthOfCodes;
    this.noLength = (this.lengthOfCodes == undefined);
    this.numberOfCodes = this.configuration.typespecifics.numberOfCodes;
    this.minimalDistance = this.configuration.typespecifics.minimalDistance;
    this.givenCodes = this.configuration.typespecifics.givenCodes;
    this.values = this.configuration.typespecifics.values;
    this.modus = this.configuration.typespecifics.modus;
    this.showCube = this.configuration.typespecifics.showCube;

    this.computeGraph();

    this.countErrors = this.minimalDistance - 1;
    this.useValues = this.values.length > 0;
    this.existingCodes = this.givenCodes.length > 0;

  }

  generateDefinition() {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/createCodes.png";
    definition.level = 1;
    definition.key = "selfcorrecting%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.lengthOfCodes = this.noLength ? undefined : this.lengthOfCodes;
    definition.typespecifics.numberOfCodes = this.numberOfCodes;
    definition.typespecifics.minimalDistance = this.minimalDistance;
    definition.typespecifics.values =  this.useValues?this.values:[];
    definition.typespecifics.givenCodes = this.existingCodes?this.givenCodes:[];
    console.log(this.givenCodes);
    definition.typespecifics.modus = this.modus;
    definition.typespecifics.showCube = this.showCube;
    definition.key = definition.key.concat("%", this.numberOfCodes ? this.numberOfCodes.toString() : "", "%", this.lengthOfCodes ? this.lengthOfCodes.toString() : "", "%", this.minimalDistance);

    return definition;
  }

  generate() {
    this.modus = Math.random() > 0.5 ? "countError" : "lengthDistance";
    this.lengthOfCodes = Math.ceil(Math.random() * 5 + 1);
    this.minimalDistance = Math.ceil(Math.random() * 2 + 1);
    while(this.maxCodes(this.lengthOfCodes, this.minimalDistance) < 2){
      this.lengthOfCodes ++;
    }
    this.numberOfCodes = Math.floor(Math.random() * (this.maxCodes(this.lengthOfCodes, this.minimalDistance)-2) + 2);
    this.countErrors = this.minimalDistance - 1;
    this.modus = Math.random() > 0.5 ? 'error' : 'distance';
    this.computeGraph();
  }

  reset() {
    super.reset();
    this.title = this.get("createCodes");
    this.values = [];
    this.lengthOfCodes = undefined;
    this.numberOfCodes = undefined;
    this.minimalDistance = undefined;
    this.givenCodes = [];
    this.values = [];
    this.modus = undefined;
    this.showCube = false;;
  }

  /** normalizes the code */
  normalizeCode(code: string) {
    return code.replace(/[^01]/, "");
  }

  /** compute the graph to show */
  computeGraph() {
    if (this.lengthOfCodes < 6 && this.lengthOfCodes > 1) {
      this.nodes = [];
      this.edges = [];
      let nodeList = this.selfcorrectingService.allCodes(this.lengthOfCodes);
      for (let n of nodeList) {
        this.nodes.push({
          id: n,
          label: n
        });
      }

      for (let i = 0; i < nodeList.length; i++) {
        for (let j = 0; j < i; j++) {
          if (this.selfcorrectingService.distance(nodeList[i], nodeList[j]) == 1) {
            this.edges.push({
              source: nodeList[i],
              target: nodeList[j],
              label: ''
            })
          }
        }
      }
    }
    else {
    }
  }

  /** returns the maximal number of possible codes given the length and the minimal distance
   * @param length - length of codes
   * @param distance - minimal distance of codes
   */
  maxCodes(length: number, distance: number) {
    if(this.noLength){
      length = 7;
    }
    if (distance == 2) {
      return Math.min(Math.pow(2, length - distance + 1),8);
    } else {
      if(length == 2){
        return 1
      }
      if(length == 3){
        return 2
      }
      return Math.min(Math.pow(2, length - distance),8);
    }
  }


}
